export const EQUIPMENT_DOMAINS = [
  { id: 'all', label: 'Wszystkie' },
  { id: 'video', label: 'Video' },
  { id: 'audio', label: 'Audio' },
  { id: 'lighting', label: 'Oświetlenie' },
  { id: 'computer', label: 'Sprzęt komputerowy' },
];

export const VIDEO_SUBCATEGORIES = ['camera', 'switcher', 'tripod', 'lens', 'recorder', 'monitor', 'converter', 'scaler', 'capture'];
export const AUDIO_SUBCATEGORIES = ['microphone', 'speaker', 'console', 'stagebox', 'wireless-sys', 'interface', 'processor', 'amplifier', 'iem-system'];

const CONVERTER_SUBCATEGORIES = new Set([
  'converter', 'scaler', 'capture', 'dante-adapter', 'ndi-encoder', 'ndi-decoder', 'streaming-encoder',
]);

export function getAssetKind(device = {}) {
  if (device.assetKind) return device.assetKind;
  return CONVERTER_SUBCATEGORIES.has(device.subcategory) ? 'converter' : 'equipment';
}

export function normalizeDomain(category = '') {
  if (category === 'display') return 'video';
  if (category === 'network-av') return 'computer';
  return category || 'video';
}
